<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2024-03-05 09:24:51
 * @LastEditors: hexy
 * @LastEditTime: 2024-03-20 17:34:22
 * @Description: 配合比维护-历史记录
 * @FilePath: \ICPSxin\src\views\platform\ICPS\basicConfig\components\ratioHistory.vue
-->
<template>
  <el-dialog :visible.sync="isHistoryDialog" width="1180px" :close-on-click-modal="false" :append-to-body="true" :before-close="resetRawFromDate" @open="openDig()">
    <span slot="title" class="dialog-title">历史记录</span>
    <div class="dialoginfo">
      <el-row>
        <el-col :span="6"
          ><span>任务号:{{ config.orderNo }}</span></el-col
        >
        <el-col :span="12"
          ><span>工程项目:{{ config.engineeringName }}</span></el-col
        >
        <el-col :span="6"
          ><span>产品名称:{{ config.productName }}</span></el-col
        >
      </el-row>
      <div style="margin-top: 10px">
        <el-table
          ref="multipleTable"
          key="multipleTable"
          :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }"
          border
          stripe
          style="width: 100%"
          :height="screenHeight - 500"
          :data="tableData"
          tooltip-effect="dark"
          :span-method="objectSpanMethod"
        >
          <template v-for="(item, index) in table">
            <el-table-column v-if="item.status" :key="index" :prop="item.prop" :label="item.label" align="center" :min-width="item.width">
              <template v-for="(item2, index2) in item.arr">
                <el-table-column v-if="item2.status" :key="index2" :label="item2.label" :prop="item2.prop" align="center" :min-width="item2.width">
                  <template slot-scope="scope">
                    <span v-if="item.label == '状态'">
                      <span v-if="scope.row[item2.prop] == 0">禁用</span>
                      <span v-if="scope.row[item2.prop] == 1">启用</span>
                    </span>
                    <span v-else>{{ scope.row[item2.prop] }}</span>
                  </template>
                </el-table-column>
              </template>
              <template slot-scope="scope">
                <span v-if="item.label == '状态'">
                  <span v-if="scope.row[item.prop] == 0">禁用</span>
                  <span v-if="scope.row[item.prop] == 1">启用</span>
                </span>
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="resetRawFromDate">关 闭</el-button>
    </span>
  </el-dialog>
</template>
  
  <script>
import { queryHistoryByPlan } from "@/api/basicConfig/mixIssue.js";
// import { mapGetters } from "vuex";
export default {
  data() {
    return {
      /*表格增删改查及下载接口*/
      options: [],
      /*表格数据*/
      rawDialogTitle: "选择原物料",
      screenHeight: "",
      tableParam: {
        page: 1,
        pageSize: 10,
        driverName: "",
        type: 1,
        supplierId: "",
        supplierName: "",
      },
      total: 0,
      tableData: [],
      table: [
        { prop: "createUserName", label: "修改人", width: "atuo", status: true },
        { prop: "version", label: "版本", width: "atuo", status: true },
        { prop: "createTime", label: "修改时间", width: "atuo", status: true },
        { prop: "lineName", label: "生产线", width: "atuo", status: true },
        { prop: "enable", label: "状态", width: "atuo", status: true },
      ],
      selectRaw: [],
      listData: {},
      detailName: "",
      mergerItems: [
        { columnIndex: 0, spanArr: [], pos: 0, prop: "createUserName" },
        { columnIndex: 1, spanArr: [], pos: 0, prop: "version" },
        { columnIndex: 2, spanArr: [], pos: 0, prop: "createTime" },
      ],
    };
  },
  props: {
    isHistoryDialog: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default: () => {},
    },
  },
  async mounted() {
    /*存储拷贝的原初始化fromDate数据*/
    //   this.tableParam = { ...this.tableParam, name: "", typeId: "", code: "", enable: 1 };
  },
  // computed: {
  //   ...mapGetters({
  //     screenHeight: "getscreenHeight",
  //   }),
  // },
  methods: {
    getSpanArr(data, array) {
      //循环数据处理
      for (let n = 0; n < array.length; n++) {
        array[n].spanArr = []; //数据清空(重新调此方法的时候需要清空上一次的数据)
        for (let i = 0; i < data.length; i++) {
          if (i === 0) {
            array[n].spanArr.push(1);
            array[n].pos = 0;
          } else {
            // 判断当前元素与上一个元素是否相同
            if (data[i][array[n].prop] === data[i - 1][array[n].prop]) {
              array[n].spanArr[array[n].pos] += 1;
              array[n].spanArr.push(0);
            } else {
              array[n].spanArr.push(1);
              array[n].pos = i;
            }
          }
        }
      }
      console.log(this.mergerItems);
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2) {
        //这里判断第几列需要合并
        let item = this.mergerItems.find(item => item.columnIndex === columnIndex);
        const _row = item.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    openDig() {
      this.getHistoryData();
    },
    getHistoryData() {
      // const proportionLists2= [];
      queryHistoryByPlan({ planId: this.config.id }).then(res => {
        if (res.code === 1001) {
          //历史数据重组
          let data = JSON.parse(JSON.stringify(res.data));
          let historyList = [];
          let historyListAll = [];
          data.forEach(item => {
            item.proportionList.forEach(item_1 => {
              historyList.push(item_1);
            });
          });
          historyList.forEach(item2 => {
            let obj = {};
            let mixArr = item2.mixInfo ? JSON.parse(item2.mixInfo) : [];
            mixArr.push({ id: "", name: "容重", theoreValue: item2.theoreValue, theoreValueTrue: item2.theoreValueTrue, deviation: "", rawFormId: "", rawList: [] });
            let unMixArr = mixArr.reduce((arr, current) => {
              let mixArrIndex = arr.findIndex(mixArrItem => mixArrItem.id == current.id);
              if (mixArrIndex != -1) {
                arr[mixArrIndex].theoreValue = arr[mixArrIndex].theoreValue * 1 + current.theoreValue * 1;
                arr[mixArrIndex].theoreValueTrue = arr[mixArrIndex].theoreValueTrue * 1 + current.theoreValueTrue * 1;
              } else {
                arr.push(current);
              }
              return arr;
            }, []);
            unMixArr.forEach(item3 => {
              obj = { ...item2, ...item3 };
              historyListAll.push(obj);
            });
          });
          let newTableData = [];
          let newTable = [
            { prop: "createUserName", label: "修改人", width: "atuo", status: true },
            { prop: "version", label: "版本", width: "atuo", status: true },
            { prop: "createTime", label: "修改时间", width: "atuo", status: true },
            { prop: "lineName", label: "生产线", width: "atuo", status: true },
            { prop: "enable", label: "状态", width: "atuo", status: true },
          ];
          historyListAll.forEach(item4 => {
            let haveTableHead = newTable.findIndex(item5 => item5.label == item4.name);
            if (haveTableHead == -1 && item4.enable != 0) {
              let objTable = {
                prop: "",
                label: item4.name,
                width: "atuo",
                status: true,
                arr: [
                  { prop: item4.name + "_theoreValue", label: "理论用量", width: "atuo", status: true },
                  { prop: item4.name + "_theoreValueTrue", label: "实际用量", width: "atuo", status: true },
                ],
              };
              newTable.push(objTable);
            }
            let haveMainDataIndex = newTableData.findIndex(item6 => item6.createUserName == item4.createUserName && item6.version == item4.version && item6.lineName == item4.lineName);
            if (haveMainDataIndex == -1) {
              let objData = {
                createUserName: item4.createUserName,
                version: item4.version,
                createTime: item4.createTime,
                lineName: item4.lineName,
                enable: item4.enable,
              };
              objData[item4.name + "_theoreValue"] = item4.enable == 0 ? null : item4.theoreValue;
              objData[item4.name + "_theoreValueTrue"] = item4.enable == 0 ? null : item4.theoreValueTrue;
              newTableData.push(objData);
            } else {
              newTableData[haveMainDataIndex][item4.name + "_theoreValue"] = item4.enable == 0 ? null : item4.theoreValue;
              newTableData[haveMainDataIndex][item4.name + "_theoreValueTrue"] = item4.enable == 0 ? null : item4.theoreValueTrue;
            }
          });

          //将容重放到最后
          let tableLast = {};
          console.log(newTable);
          newTable.forEach((item, index) => {
            if (item.label == "容重") {
              tableLast = item;
              newTable.splice(index, 1);
              newTable.push(tableLast);
            }
          });
          //排序
          newTableData.sort((a, b) => {
            if (a.createTime !== b.createTime) {
              return a.createTime > b.createTime ? -1 : 1;
            } else if (a.createUserName !== b.createUserName) {
              return a.createUserName < b.createUserName ? -1 : 1;
            } else if (a.version !== b.version) {
              return a.version < b.version ? -1 : 1;
            }
          });
          console.log(newTableData);
          console.log(newTable);
          this.tableData = newTableData;
          this.table = newTable;
          this.screenHeight = document.documentElement.clientHeight;
          this.getSpanArr(this.tableData, this.mergerItems);
          this.$refs.multipleTable.doLayout();
          this.$forceUpdate();
        }
      });
    },
    resetRawFromDate() {
      this.$emit("update:isHistoryDialog", false);
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.title_box {
  display: block;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 22px;
  color: #000000;
  margin-bottom: 10px;
}
.el-form-item__label {
  color: #000000;
  font-size: 14px;
}
.table_link {
  margin-left: 10px;
  color: $bg_color;
}
.table_link:hover {
  opacity: 0.8;
}
</style>
  